module.exports = __webpack_public_path__ + "img/t-green.fb9f1d88.svg";